var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 44 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001---Lock",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#ffdc00",
    height: 29,
    rx: 3,
    width: 42,
    x: 1,
    y: 25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m40 25h-3c1.6568542 0 3 1.3431458 3 3v23c0 1.6568542-1.3431458 3-3 3h3c1.6568542 0 3-1.3431458 3-3v-23c0-1.6568542-1.3431458-3-3-3z",
    fill: "#fec108"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m17 22v3h-12v-3c0-1.6568542 1.34314575-3 3-3h6c1.6568542 0 3 1.3431458 3 3z",
    fill: "#7f8e94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m14 19h-3c1.6568542 0 3 1.3431458 3 3v3h3v-3c0-1.6568542-1.3431458-3-3-3z",
    fill: "#545c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m39 22v3h-12v-3c0-1.6568542 1.3431458-3 3-3h6c1.6568542 0 3 1.3431458 3 3z",
    fill: "#7f8e94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m36 19h-3c1.6568542 0 3 1.3431458 3 3v3h3v-3c0-1.6568542-1.3431458-3-3-3z",
    fill: "#545c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m36 12v7h-6v-7c0-2.76142375-2.2385763-5-5-5h-6c-2.7614237 0-5 2.23857625-5 5v7h-6v-7c.00386129-6.07353213 4.9264679-10.99613871 11-11h6c6.0735321.00386129 10.9961387 4.92646787 11 11z",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m11 12v7h3v-7c0-2.76142375 2.2385763-5 5-5h-3c-2.7614237 0-5 2.23857625-5 5z",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m25 1h-3c6.0735321.00386129 10.9961387 4.92646787 11 11v7h3v-7c-.0038613-6.07353213-4.9264679-10.99613871-11-11z",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m40 54v2c0 1.6568542-1.3431458 3-3 3h-30c-1.65685425 0-3-1.3431458-3-3v-2z",
    fill: "#ff9801"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m37 54v2c0 1.6568542-1.3431458 3-3 3h3c1.6568542 0 3-1.3431458 3-3v-2z",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m24.473 41.119.987 4.448c.1313206.5921755-.0131957 1.2119499-.3928936 1.6849683s-.9535449.7481636-1.5601064.7480317h-3.014c-.6065615.0001319-1.1804085-.2750133-1.5601064-.7480317s-.5242142-1.0927928-.3928936-1.6849683l.987-4.448c.0908033-.3818168-.0571702-.7807534-.375-1.011-1.796317-1.2461599-2.574721-3.5148675-1.9218507-5.6013549.6528704-2.0864873 2.5856053-3.5068686 4.7718507-3.5068686s4.1189803 1.4203813 4.7718507 3.5068686c.6528703 2.0864874-.1255337 4.355195-1.9218507 5.6013549-.3186515.2297358-.4681037.6284065-.379 1.011z",
    fill: "#624421"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff9801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m9 45h-8c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h8c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m13 49h-12c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h12c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m43 45h-8c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h8c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m43 49h-12c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h12c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m39 34c-.5522847 0-1-.4477153-1-1v-3h-3c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h4c.5522847 0 1 .4477153 1 1v4c0 .5522847-.4477153 1-1 1z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m3 54.858v1.142c0 2.209139 1.790861 4 4 4h30c2.209139 0 4-1.790861 4-4v-1.142c1.7606851-.4545933 2.9931852-2.0395884 3-3.858v-23c0-2.209139-1.790861-4-4-4v-2c-.0068148-1.8184116-1.2393149-3.4034067-3-3.858v-6.142c-.0071648-6.62444695-5.375553-11.99283515-12-12h-6c-6.624447.00716485-11.99283515 5.37555305-12 12v6.142c-1.76068514.4545933-2.99318518 2.0395884-3 3.858v2c-2.209139 0-4 1.790861-4 4v3c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-3c0-1.1045695.8954305-2 2-2h36c1.1045695 0 2 .8954305 2 2v23c0 1.1045695-.8954305 2-2 2h-4c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h3v1c0 1.1045695-.8954305 2-2 2h-30c-1.1045695 0-2-.8954305-2-2v-1h26c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-27c-1.1045695 0-2-.8954305-2-2v-15c0-.5522847-.44771525-1-1-1s-1 .4477153-1 1v15c.00681482 1.8184116 1.23931486 3.4034067 3 3.858zm16-52.858h6c5.5203344.00606237 9.9939376 4.47966557 10 10v6h-4v-6c-.0033074-3.31233757-2.6876624-5.99669262-6-6h-6c-3.3123376.00330738-5.9966926 2.68766243-6 6v6h-4v-6c.00606237-5.52033443 4.4796656-9.99393763 10-10zm7 20v2h-8v-2c-.0068148-1.8184116-1.2393149-3.4034067-3-3.858v-6.142c0-2.209139 1.790861-4 4-4h6c2.209139 0 4 1.790861 4 4v6.142c-1.7606851.4545933-2.9931852 2.0395884-3 3.858zm-20 2v-2c0-1.1045695.8954305-2 2-2h6c1.1045695 0 2 .8954305 2 2v2zm22 0v-2c0-1.1045695.8954305-2 2-2h6c1.1045695 0 2 .8954305 2 2v2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m28 36c.0045621-2.846096-1.9910113-5.3037989-4.777399-5.883736-2.7863876-.579937-5.5968238.8774804-6.7281787 3.4890545s-.2722992 5.6586449 2.0565777 7.2946815l-.987 4.448c-.1978388.8885424.0184634 1.8188521.5880009 2.5289753s1.4306982 1.1232394 2.3409991 1.1230247h3.014c.9098639.0000798 1.7705988-.4127691 2.3400525-1.1223991.5694538-.7096299.7860847-1.6393503.5889475-2.5276009l-.986-4.443c1.5956872-1.1251572 2.5463438-2.9545188 2.55-4.907zm-3.723 3.287c-.6529542.4604676-.9614615 1.2708925-.78 2.049l.987 4.448c.0655041.2961003-.0068976.6059288-.1968397.8423356-.189942.2364069-.4769011.3738484-.7801603.3736644h-3.014c-.3032592.000184-.5902183-.1372575-.7801603-.3736644-.1899421-.2364068-.2623438-.5462353-.1968397-.8423356l.987-4.448c.1815158-.7775987-.1265867-1.5876038-.779-2.048-1.3113864-.9053827-1.9602619-2.5027994-1.6517059-4.0662076.3085559-1.5634082 1.5156738-2.794524 3.0727059-3.1337924.284266-.0585869.5737595-.0880723.864-.088.9179134-.0023192 1.8078162.3160086 2.516.9.9743389.7940534 1.5187754 1.9999066 1.4700148 3.2558841s-.6850466 2.4159918-1.7180148 3.1321159z",
    fill: "#000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.025d9c2cdc691e6408e31886d8b5d056.svg";
export { ForwardRef as ReactComponent };